module.exports = __webpack_public_path__ + "static/media/simarya.32780bef.jpeg";